import React from 'react'
import Card from "@material-ui/core/Card";
import Alert from "@material-ui/lab/Alert";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import {FormatNumber} from "../../helpers/Helpers";
import Api from "../../helpers/Api";
import Env from "../../config/env";
import AppToast from "../../ui/AppToast";
import {confirmAlert} from "react-confirm-alert";

class DonationsList extends React.Component {

    handleDelete = async (obj) => {
        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h3>¿Desea borrar el aporte por valor de $ {FormatNumber.new(obj.value)}?</h3>
                        <button onClick={onClose}>No</button>
                        <button className='custom-ui-btn-si'
                            onClick={async () => {

                                onClose();

                                const params = {
                                    id: obj.id,
                                }
                                const data = await Api.post(`${Env.UrlBackend}/donations/delete`, params);
                                AppToast(data.message, data.success);
                                if (data.success) {
                                    await this.props.getDonations();
                                }

                            }}
                        >
                            Si
                        </button>
                    </div>
                );
            }
        });
    }

    render() {
        const {data} = this.props;

        if (data.length === 0) {
            return (
                <div style={{paddingLeft: '30px', paddingRight: '30px'}}>
                    <br/>
                    <Alert severity="info">No ha enviado ninguna donación!</Alert>
                </div>
            );
        }

        return (
            <div style={{paddingLeft: '30px', paddingRight: '30px', marginBottom: '2%'}}>
                <Card>
                    <table className='custom-table'>
                        <thead>
                        <tr>
                            <th>Cuenta</th>
                            <th>Valor Aporte</th>
                            <th style={{width: '15%'}}>Fecha Aporte</th>
                            <th>Estado</th>
                            <th style={{width: '15%'}}>Fecha Retiro</th>
                            <th>Borrar</th>
                        </tr>
                        </thead>
                        <tbody>

                        {data.map((val, index) => {
                            return (
                                <tr key={index}>
                                    <td>{val.account}</td>
                                    <td>$ {FormatNumber.new(val.value)}</td>
                                    <td>{val.created_at_format}</td>
                                    <td>{val.status_text}</td>
                                    <td>{val.deleted_at_format}</td>

                                    { /*SOLO SE PUEDEN ELIMINAR LOS QUE CUMPLAN CON LA CONDICION*/
                                        val.allow_delete ?
                                            <td style={{padding: '0px'}}>
                                                <Tooltip title="Eliminar donación">
                                                    <IconButton color="secondary" onClick={() => {
                                                        this.handleDelete(val)
                                                    }} aria-label="add to shopping cart">
                                                        <DeleteForeverIcon/>
                                                    </IconButton>
                                                </Tooltip>
                                            </td>

                                            : <td style={{padding: '22px'}}></td>
                                    }

                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </Card>
            </div>
        );
    }
}

export default DonationsList